export default [
  [
    { title: "What should I wear?", link: "/wsiw" },
    { title: "Home", link: "/wsiw" },
    { title: "Support", link: "/wsiw/support" },
    { title: "Builds", link: "/wsiw/builds" },
    { title: "Terms & Conditions", link: "/wsiw/terms" }
  ],
  [
    { title: "MedFlex", link: "/wsiw" },
    { title: "Home", link: "/wsiw" },
    { title: "Support", link: "/wsiw/support" },
    { title: "Builds", link: "/wsiw/builds" },
    { title: "Terms & Conditions", link: "/wsiw/terms" }
  ],
  [
    { title: "Pocket Caddy", link: "/wsiw" },
    { title: "Home", link: "/wsiw" },
    { title: "Support", link: "/wsiw/support" },
    { title: "Builds", link: "/wsiw/builds" },
    { title: "Terms & Conditions", link: "/wsiw/terms" }
  ],
  [
    { title: "Unbiased News", link: "/wsiw" },
    { title: "Home", link: "/wsiw" },
    { title: "Support", link: "/wsiw/support" },
    { title: "Builds", link: "/wsiw/builds" },
    { title: "Terms & Conditions", link: "/wsiw/terms" }
  ],
  [
    { title: "Rally", link: "/wsiw" },
    { title: "Home", link: "/wsiw" },
    { title: "Support", link: "/wsiw/support" },
    { title: "Builds", link: "/wsiw/builds" },
    { title: "Terms & Conditions", link: "/wsiw/terms" }
  ]
];
